import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'baseui/snackbar'
import { selectAddressesConfigData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { updateAddressesConfigData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'

const useDeleteAddressModals = () => {
  const dispatch = useDispatch()
  const { enqueue } = useSnackbar()
  const { deleteAddressModal, deleteAddressBlockedModal, deleteAddressIsLoading } =
    useSelector(selectAddressesConfigData)

  const closeBlockedModal = () => {
    // @ts-ignore
    dispatch(updateAddressesConfigData({ deleteAddressBlockedModal: false, addressToDeleteId: null }))
  }

  const closeConfirmModal = () => {
    // @ts-ignore
    dispatch(updateAddressesConfigData({ deleteAddressModal: false, addressToDeleteId: null }))
  }

  const handleConfirmDelete = () => {
    dispatch({ type: subscriptionFormActionsV2.ADDRESS_CONFIRM_DELETE, enqueue })
  }

  return {
    deleteAddressModal,
    deleteAddressBlockedModal,
    deleteAddressIsLoading,
    closeBlockedModal,
    closeConfirmModal,
    handleConfirmDelete,
  }
}

export default useDeleteAddressModals
